var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/global"
  }, /*#__PURE__*/React.createElement("g", {
    id: "global"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1109 18.8333C14.7133 18.8333 18.4443 15.1023 18.4443 10.5C18.4443 5.89759 14.7133 2.16663 10.1109 2.16663C5.50855 2.16663 1.77759 5.89759 1.77759 10.5C1.77759 15.1023 5.50855 18.8333 10.1109 18.8333Z",
    stroke: "#347AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.77751 3H7.61084C5.98584 7.86667 5.98584 13.1333 7.61084 18H6.77751",
    stroke: "#347AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.6108 3C14.2358 7.86667 14.2358 13.1333 12.6108 18",
    stroke: "#347AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.61084 13.8333V13C7.47751 14.625 12.7442 14.625 17.6108 13V13.8333",
    stroke: "#347AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.61084 8C7.47751 6.375 12.7442 6.375 17.6108 8",
    stroke: "#347AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSvg);
export default __webpack_public_path__ + "static/media/GlobalSvg.8eaf129db999ba97a25771929bc0de96.svg";
export { ForwardRef as ReactComponent };